import { ADMIN_ROLE, PERMISSIONS } from 'routes/admin/constants';

export const checkAdminPermissions = (role: ADMIN_ROLE, scope: string[]) => {
  return PERMISSIONS[role] && PERMISSIONS[role].some((permission) => scope.includes(permission));
};
